import { createActionTypeReducer } from '../../../middleware'

const initialState = {
}

export const predictionConfigEditorReducer = createActionTypeReducer( initialState, {
})


// WEBPACK FOOTER //
// ./src/App/SolutionEditor/Predictions/reducers.js